import React, { useState } from 'react';
import { Button, Form, Stack } from 'react-bootstrap';

interface FeedbackAction {
  url: string;
  method: string;
  inputPlaceholder?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

interface FeedbackBlock {
  label: string;
  action: FeedbackAction;
}

interface FeedbackInputBlockProps {
  block: FeedbackBlock;
}

const FeedbackInputBlock: React.FC<FeedbackInputBlockProps> = ({ block }) => {
  const [feedback, setFeedback] = useState<string>('');

  const handleSubmit = async () => {
    try {
      const response = await fetch(block.action.url, {
        method: block.action.method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ feedback }),
      });

      if (response.ok) {
        setFeedback('');
        // You might want to add a success notification here
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      // You might want to add an error notification here
    }
  };

  return (
    <Form className="feedback-input-block">
      <Form.Group>
        <Form.Label>{block.label}</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder={block.action.inputPlaceholder}
          value={feedback}
          onChange={e => setFeedback(e.target.value)}
        />
      </Form.Group>
      <Stack direction="horizontal" gap={2} className="mt-3">
        <Button variant="primary" onClick={handleSubmit}>
          {block.action.confirmLabel}
        </Button>
        <Button variant="outline-secondary" onClick={() => setFeedback('')}>
          {block.action.cancelLabel}
        </Button>
      </Stack>
    </Form>
  );
};

export default FeedbackInputBlock;
